<template>
  <v-list>
    <v-subheader>
      <v-btn icon @click="drawerChange(false)" v-if="$vuetify.breakpoint.xsOnly">
        <v-icon>mdi-close</v-icon>
      </v-btn>
      STEROWANIE MAPĄ
    </v-subheader>


    <v-list-item>
      <v-list-item-icon>
        <v-icon>mdi-target</v-icon>
      </v-list-item-icon>
      <v-list-item-content>
        <v-list-item-title>
          Ustawianie pozycji
        </v-list-item-title>
      </v-list-item-content>
      <v-list-item-action>
        <v-switch
          :input-value="selectLocationMode"
          @change="handleLocationModeChange"
          label=""
          :true-value="true"
          :false-value="false"
          color="primary"
        >
        </v-switch>
      </v-list-item-action>
    </v-list-item>

    <v-subheader>
      FILTRY
    </v-subheader>

    <v-list-item>
      <v-list-item-icon>
        <v-icon>mdi-car-brake-parking</v-icon>
      </v-list-item-icon>
      <v-list-item-content>
        <v-list-item-title>
          Parkingi
        </v-list-item-title>
      </v-list-item-content>
      <v-list-item-action>
        <v-switch
          :input-value="parkingsLayer"
          @change="handleParkingsChange"
          label=""
          :true-value="true"
          :false-value="false"
          color="primary"
        >
        </v-switch>
      </v-list-item-action>
    </v-list-item>

    <v-list-group
      no-action
      sub-group
    >
      <template v-slot:activator>
        <v-list-item-content>
          <v-list-item-title>Podelementy</v-list-item-title>
        </v-list-item-content>
      </template>

      <v-list-item>
        <v-list-item-icon>
          <v-icon>mdi-car</v-icon>
        </v-list-item-icon>
        <v-list-item-content>
          <v-list-item-title>
            Grupy
          </v-list-item-title>
        </v-list-item-content>
        <v-list-item-action>
          <v-switch
            :input-value="parkingGroupsLayer"
            @change="handleParkingGroupsChange"
            label=""
            :true-value="true"
            :false-value="false"
            color="primary"
          >
          </v-switch>
        </v-list-item-action>
      </v-list-item>
      <v-list-item>
        <v-list-item-icon>
          <v-icon>mdi-checkbox-blank-circle</v-icon>
        </v-list-item-icon>
        <v-list-item-content>
          <v-list-item-title>
            Miejsca
          </v-list-item-title>
        </v-list-item-content>
        <v-list-item-action>
          <v-switch
            :input-value="parkingSpotsLayer"
            @change="handleParkingSpotsChange"
            label=""
            :true-value="true"
            :false-value="false"
            color="primary"
          >
          </v-switch>
        </v-list-item-action>
      </v-list-item>
    </v-list-group>

    <v-list-item>
      <v-list-item-icon>
        <v-icon>mdi-texture-box</v-icon>
      </v-list-item-icon>
      <v-list-item-content>
        <v-list-item-title>
          Strefy parkowania
        </v-list-item-title>
      </v-list-item-content>
      <v-list-item-action>
        <v-switch
          :input-value="parkingZonesLayer"
          @change="handleParkingZonesChange"
          label=""
          :true-value="true"
          :false-value="false"
          color="primary"
        >
        </v-switch>
      </v-list-item-action>
    </v-list-item>

<!--  OG  -->
    <v-list-item>
      <v-list-item-icon>
        <v-icon class="">mdi-cash-usd-outline</v-icon>
      </v-list-item-icon>
      <v-list-item-content>
        <v-list-item-title>
          Parkometry
        </v-list-item-title>
      </v-list-item-content>
      <v-list-item-action>
        <v-switch
          :input-value="parkingMetersLayer"
          @change="handleParkingMetersChange"
          label=""
          :true-value="true"
          :false-value="false"
          color="primary"
        >
        </v-switch>
      </v-list-item-action>
    </v-list-item>
  </v-list>
</template>

<script lang="ts">
import { defineComponent } from 'vue';
import useOptions from '@/components/composers/useOptions';
import useHandleDrawer from '@/components/composers/useHandleDrawer';

const SidebarContent: object = defineComponent({
  name: 'SidebarContent',
  setup() {
    return {
      ...useOptions(),
      ...useHandleDrawer(),
    };
  },
});
export default SidebarContent;
</script>

<style scoped lang="scss">
</style>
